import { render, staticRenderFns } from "./OrderSchedulePage.vue?vue&type=template&id=a07ae164&scoped=true&"
import script from "./OrderSchedulePage.vue?vue&type=script&lang=js&"
export * from "./OrderSchedulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07ae164",
  null
  
)

export default component.exports